import { Pagination, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';

import {AiOutlinePlusCircle, AiOutlineMinusCircle} from 'react-icons/ai';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const CPFMtableNew = () => {
    const [customerList, setCustomerList] = useState([]);
    const [frequencyList, setFrequencyList] = useState([]);
    const [parentProducts, setParentProducts] = useState([]);
    const [toggleList, setToggleList] = useState([]);
    const [CPFM, setCPFM] = useState();

    const [customerIdList, setCustomerIdList] = useState([]);
    const [productIdList, setProductIdList] = useState([]);

    useEffect(() => {
        (async() => {
            const response = await fetch(`${API_BASE_URL}/customer/list`, {
                method: 'GET',
                headers: { 'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`) }
            });
            const responseData = await response.json();
            setCustomerList(responseData.data.map(item => (
                {
                    customer_id: item.customer_id,
                    customer_name: item.customer_name
                }
            )));
            setCustomerIdList(responseData.data.map(item => item.customer_id));
        })();
    }, []);

    useEffect(() => {
        (async () => {
          try {
            const response = await fetch(`${API_BASE_URL}/product/mapping`, {
              method: "GET",
              headers: {
                Authorization: "Basic " + btoa(`${USER_NAME}:${PASSWORD}`)
              }
            });
            const responseData = await response.json();
            setParentProducts(responseData.data);
            setToggleList(responseData.data.map((_, index) => (
                { index: index, open: false }
            )));
          } catch (e) {
            console.error(e);
          }
        })();
      }, []);

    useEffect(() => {
        (async () => {
            try {
              const response = await fetch(`${API_BASE_URL}/customer/frequency`, {
                method: "GET",
                headers: {
                  Authorization: "Basic " + btoa(`${USER_NAME}:${PASSWORD}`)
                }
              });
              const responseData = await response.json();
              setFrequencyList(responseData.data.map(item => (
                { value: item.Id, label: item.Frequency }
              )));
            } catch (e) {
              console.error(e);
            }
          })();
    }, []);

    useEffect(() => {
        (async () => {
            try {
              const response = await fetch(`${API_BASE_URL}/product/list`, {
                method: "GET",
                headers: {
                  Authorization: "Basic " + btoa(`${USER_NAME}:${PASSWORD}`)
                }
              });
              const responseData = await response.json();
              setProductIdList(responseData.data.map(item => item.prod_id));
            } catch (e) {
              console.error(e);
            }
          })();
    }, []);

    useEffect(() => {
        console.log(CPFM)
    }, [CPFM]);
    
    useEffect(() => {
        if (productIdList.length && customerIdList.length) {
            const maxProductId = Math.max(...productIdList);
            const maxCustomerId = Math.max(...customerIdList);
            let matrix = Array(maxProductId  + 1).fill(0).map((row, index) =>      
                new Array(maxCustomerId + 1).fill(0)
            )
            productIdList.forEach((productId) => {
                customerIdList.forEach((customerId) => {
                    matrix[productId][customerId] = 0;
                })
            });
            setCPFM(matrix);
        }
    }, [productIdList, customerIdList]);

    const postData = async (matrix) => {
        const details = {
            'name': matrix,
        };

        // var formBody = [];
        // for (let property in details) {
        // var encodedKey = encodeURIComponent(property);
        // var encodedValue = encodeURIComponent(details[property]);
        // formBody.push(encodedKey + "=" + encodedValue);
        // }
        // formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/customer_product/frequency`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(details)
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                console.log(responseData);
            } else {

            }
        } catch (error) {
            console.error(error);
        }
    }

      const collapseHandler = (index) => {
        const toggle_list = [...toggleList];
        toggle_list[index].open = !toggle_list[index].open;
        setToggleList(toggle_list);
      }

    return (
        <Wrapper>
                <table>
                    {parentProducts.map((parent_product, index) => (  
                        <>
                        <thead>
                            {index === 0 &&
                            <tr>
                                <th>Products</th>
                                {customerList.map(item => (
                                    <th key={item.customer_id}>{item.customer_name}</th>
                                ))}
                            </tr>}
                        </thead>
                        <tbody>
                            <ProductToggler onClick={() => collapseHandler(index)}>
                                <span>{parent_product.parent_product_name}</span>
                                {toggleList[index].open ? <AiOutlineMinusCircle className='toggle-icon open' /> : <AiOutlinePlusCircle className='toggle-icon' />}
                            </ProductToggler>
                            {parent_product.sub_product.map(product => (
                            <>
                                {toggleList[index].open && 
                                <tr key={product.prod_id}>
                                    <td>{product.prod_name}</td>
                                    {customerList.map(customer => (
                                    <td className='text-center'>
                                        <Select 
                                            placeholder="Frequency"
                                            options={frequencyList}
                                            size='small'
                                            onChange={(value) => {
                                                console.log(`Product Id: ${product.prod_id}, Customer Id: ${customer.customer_id}, Frequency: ${value}`);
                                                const matrix = [...CPFM];
                                                matrix[product.prod_id][customer.customer_id] = value;
                                                setCPFM(matrix);
                                                postData(matrix);
                                            }}
                                            allowClear
                                            value={CPFM[product.prod_id][customer.customer_id]}
                                        />
                                    </td>
                                    ))}
                                </tr>}
                            </>))}
                        </tbody>
                        </>
                    ))}
                    </table>
        </Wrapper>
    );
}

export default CPFMtableNew;

const Wrapper = styled.div`
    margin-top: 2rem;
    table {
        width: 95%;
        margin: auto;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        
    }
    table, th, td {
        border: 1.5px solid #F0F0F0;
        border-collapse: collapse;
    }
    thead {
        background: ${({theme}) => theme.colors.primary};
        color: #fff;
    }
    tbody {
        
    }
    td{
        font-size: 1.5rem;
        letter-spacing: 0.05rem;
        color: #000;
        border: 1px solid #F0F0F0;
        border-left: 1.5px solid #F0F0F0;
        padding: 1.5rem 2.5rem;
    }
    th {
        padding: 1.5rem 2.5rem;
        font-size: 1.8rem;
    }
    .text-center {
        text-align: center;
    }  
`;
const ProductToggler = styled.button`
    cursor: pointer;
    border: none;
    width: 100%;
    padding: 2rem;
    padding-right: 3rem;
    font-size: 1.8rem;
    display: flex;
    justify-content: space-between;
    color: ${({theme}) => theme.colors.primary};
    background-color: white;
    text-align: left;
    &:hover {
        background-color: ${({theme}) => theme.colors.bg};
    }
    .toggle-icon {
        font-size: 2rem;
        color: #10ac84;
    }
    .toggle-icon.open {
        color: #ff6b6b;
    }
`;
